import ReactDOM from 'react-dom';
import React from 'react';
import { AlertBox, ConfirmBox, LoadingBox, ToastBox } from './components';
type Fn = () => void;

interface ConfirmParams {
  title?: React.ReactNode;
  subTitle: React.ReactNode;
  className?: string;
  okBtnText?: string;
  cancelBtnText?: string;
  okCallback?: Fn;
  cancelCallback?: (arg?: string) => void;
}

interface AlertParams {
  title?: React.ReactNode;
  subTitle: React.ReactNode;
  okBtnText?: string;
  className?: string;
  okCallback?: Fn;
  hideCloseIcon?: boolean;
  renderButton?: () => any;
  closeCallback?: (arg?: string) => void;
}

interface ToastParams {
  content: string;
  duration?: number;
  className?: string;
  selfAdaption?: boolean;
}

class Message {
  loadingDomWrap: HTMLDivElement | null = null;

  $toast(params: ToastParams) {
    const {
      content,
      duration = 2000,
      className,
      selfAdaption = false,
    } = params;
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(
      <ToastBox
        content={content}
        duration={duration}
        domWrap={div}
        className={className}
        selfAdaption={selfAdaption}
      />,
      div
    );
  }

  $toastV2(params: ToastParams) {
    const { content, duration = 2000, className, selfAdaption = true } = params;
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(
      <ToastBox
        content={content}
        duration={duration}
        domWrap={div}
        className={className}
        selfAdaption={selfAdaption}
      />,
      div
    );
  }

  $loadingShow(content = '正在加载...') {
    if (this.loadingDomWrap) {
      return;
    }
    const div = document.createElement('div');
    this.loadingDomWrap = div;
    document.body.appendChild(div);
    ReactDOM.render(<LoadingBox content={content} />, div);
  }

  $loadingHide() {
    if (this.loadingDomWrap) {
      ReactDOM.unmountComponentAtNode(this.loadingDomWrap);
      document.body.removeChild(this.loadingDomWrap);
      this.loadingDomWrap = null;
    }
  }

  $confirm(params: ConfirmParams) {
    const {
      title = '提示',
      subTitle,
      okBtnText = '确定',
      cancelBtnText = '取消',
      okCallback,
      cancelCallback,
      className,
    } = params;
    const div = document.createElement('div');
    this.loadingDomWrap = div;
    document.body.appendChild(div);
    ReactDOM.render(
      <ConfirmBox
        title={title}
        subTitle={subTitle}
        okBtnText={okBtnText}
        cancelBtnText={cancelBtnText}
        okCallback={okCallback}
        cancelCallback={cancelCallback}
        domWrap={div}
        className={className}
        onClose={() => {
          this.loadingDomWrap = null;
        }}
      />,
      div
    );
  }

  // alert
  $alert(params: AlertParams) {
    const {
      title = '',
      subTitle,
      okBtnText = '确定',
      okCallback,
      renderButton,
      className,
      hideCloseIcon,
      closeCallback,
    } = params;
    const div = document.createElement('div');
    this.loadingDomWrap = div;
    document.body.appendChild(div);
    ReactDOM.render(
      <AlertBox
        title={title}
        subTitle={subTitle}
        okBtnText={okBtnText}
        okCallback={okCallback}
        renderButton={renderButton}
        domWrap={div}
        className={className}
        onClose={() => {
          if (closeCallback) {
            closeCallback();
          }
          this.loadingDomWrap = null;
        }}
        hideCloseIcon={hideCloseIcon}
      />,
      div
    );
  }
}

export default new Message();
